import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MedicareDto } from '../model/medicareDto';
import { POLICYHOLDERTYPE } from '../model/constants';
import { PolicyMemberDto } from '../model/policyMemberDto';

export class SurveyOtherHealthInsuranceHelper {
    //#region Public Variables
    //#endregion Public Variables

    //#region Private Variables
    private static fb: FormBuilder = new FormBuilder();
    //#endregion Private Variables

    //#region Properties
    //#endregion Properties

    //#region Constructor
    //#endregion Constructor

    //#region Public Methods
    public static CreateOtherHealthInsuranceFormGroup(surveyResponseId : number): FormGroup{
        return this.fb.group({
            SurveyResponseId: [surveyResponseId, Validators.required],
            OtherHealthInsuranceId: [0, Validators.required],
            HasOtherHealthInsurance: ['', Validators.required],
            PolicyHolders: this.fb.array([]),
            HasCoverage:[''],
            HasCoveredMedicare:['', Validators.required],
            InsuranceNameBeneficiary:['', Validators.required],
            InsuranceMedicareId:['', Validators.required],
            InsuranceEffectiveDateHospital:[null, Validators.required],
            InsuranceEffectiveDateMedical:[null, Validators.required]
        });
    }

    public static CreatePolicyHolderFormGroup() : FormGroup{
        return this.fb.group({
            PolicyHolderId: [0],
            OtherHealthInsuranceId: [0],
            PolicyHolderType: [POLICYHOLDERTYPE.IsSelf],
            IsSelf: [true],
            IsSpouse: [false],
            IsDependent: [false],
            IsOther: [false],
            PolicyHolderOther: [''],
            PolicyHolderName: ['', Validators.required],
            PolicyHolderDateOfBirth: [null, Validators.required],
            PolicyHolderIdentification: ['', Validators.required],
            PolicyHolderNameOfTheCarrier: ['', Validators.required],
            PolicyCarrierCustomerService:['', Validators.required],
            HasOtherPolicyMembers:['', Validators.required],
            PolicyMembers: this.fb.array([])
        });
    }

    public static CreatePolicyHolderMemberFormGroup() : FormGroup{
        return this.fb.group({
            PolicyMemberId: [0],
            PolicyHolderId: [0],
            PolicyMemberName: ['', Validators.required],
            PolicyMemberDateOfBirth: [null, Validators.required],
            PolicyMemberIdentification: ['', Validators.required]
        });
    }

    public static CreatePolicyMemberFormGroup(policyMemberDto: PolicyMemberDto) : FormGroup{
        return this.fb.group({
            PolicyMemberId: [policyMemberDto.PolicyMemberId || 0],
            PolicyHolderId: [policyMemberDto.PolicyHolderId || 0],
            PolicyMemberName: [policyMemberDto.PolicyMemberName || '', Validators.required],
            PolicyMemberDateOfBirth: [policyMemberDto.PolicyMemberDateOfBirth || null, Validators.required],
            PolicyMemberIdentification: [policyMemberDto.PolicyMemberIdentification || '', Validators.required]
        });
    }

    public static CreateMedicareFormGroup(medicareDto: MedicareDto) : FormGroup{
        return this.fb.group({
            InsuranceNameBeneficiary: [{ value: medicareDto.InsuranceNameBeneficiary || '', disabled: true}],
            InsuranceMedicareId: [{ value: medicareDto.InsuranceMedicareId || '', disabled: true}],
            InsuranceEffectiveDateHospital: [{ value: medicareDto.InsuranceEffectiveDateHospital || null, disabled: true}],
            InsuranceEffectiveDateMedical: [{ value: medicareDto.InsuranceEffectiveDateMedical || null, disabled: true}],
        });
    }

    public static CreatePolicyHolderSummaryFormGroup() : FormGroup{
        return this.fb.group({
            PolicyHolderId: [0],
            OtherHealthInsuranceId: [0],
            PolicyHolderType: [POLICYHOLDERTYPE.IsSelf],
            IsSelf: [true],
            IsSpouse: [false],
            IsDependent: [false],
            IsOther: [false],
            PolicyHolderOther: [{ value: '', disabled: true}],
            PolicyHolderName: [{ value: '', disabled: true}],
            PolicyHolderDateOfBirth: [{ value: null, disabled: true}],
            PolicyHolderIdentification: [{ value: '', disabled: true}],
            PolicyHolderNameOfTheCarrier: [{ value: '', disabled: true}],
            PolicyCarrierCustomerService:[{ value: '', disabled: true}],
            HasOtherPolicyMembers:[{ value: '', disabled: true}],
            PolicyMembers: this.fb.array([])
        });
    }
    //#endregion Public Methods

    //#region Private Methods
    //#endregion Private Methods
}
